import React from 'react';
import { useLocation, useNavigate, Routes, Route, Navigate } from 'react-router-dom';

import { PAGES, PATHS } from './constants';
import Main from './containers/Main';
import Login from './containers/Login';
import Menu from './containers/Menu';
import SoccerOddsHistory1 from './containers/OddsHistory1/Soccer';
import Teams from './containers/Teams';
import UserSettings from './containers/Admin/UserSettings';
import RolesSettings from './containers/Admin/RoleSettings';
import Profile from './containers/Profile';
import ResultsIframe from './components/MenuItems/Results/ResultsIframe';
import SoccerEvents from './containers/Events/Soccer';
import TennisEvents from './containers/Events/Tennis';
import TennisOddsHistory1 from './containers/OddsHistory1/Tennis';
import SoccerOddsHistory2 from './containers/OddsHistory2/Soccer';
import TennisOddsHistory2 from './containers/OddsHistory2/Tennis';
import MatchTimeline from './containers/MatchTimeline/Soccer';
import TennisMatchTimeline from './containers/MatchTimeline/Tennis';
import SoccerFeedSettings from './containers/Settings/FeedSettings/Soccer';
import TennisFeedSettings from './containers/Settings/FeedSettings/Tennis';
import SoccerMarketSettings from './containers/Settings/MarketSettings/Soccer';
import TennisMarketSettings from './containers/Settings/MarketSettings/Tennis';
import SoccerAutoBooking from './containers/AutoBooking/Soccer';
import TennisAutoBooking from './containers/AutoBooking/Tennis';
import MarketMarginsSoccer from './containers/Settings/MarketMargins/Soccer';
import MarketMarginsTennis from './containers/Settings/MarketMargins/Tennis';
import EarlyPayoutSettings from './containers/Settings/EarlyPayoutSettings';
import GoldenGoalSettings from './containers/Settings/GoldenGoalSettings';
import SoccerPlayerTemplate from './containers/PlayersTemplate/Soccer';
import TennisLiveTemplate from './containers/PlayersTemplate/Tennis';
import SoccerPlayersTemplateFile from './containers/PlayersTemplateFile/Soccer';
import LiveTemplate from './containers/PlayersTemplate/Soccer/LiveTemplate';
import LiveTemplateFile from './containers/PlayersTemplateFile/Soccer/LiveTemplateFile';
import TennisLiveTemplateFile from './containers/PlayersTemplateFile/Tennis';
import LiveScoreStatus from './containers/LiveScoreStatus';
import HistoricalEvents from './containers/HistoricalEvents/Soccer';
import PrematchMarket from './containers/Settings/PrematchMarket';
import FeaturesFlag from './containers/Settings/FeaturesFlag';
import RoundSpecials from './containers/RoundSpecialsEvents';
import RoundSpecialsMatchTimeline from './containers/RoundSpecialsMatchTimeline';
import RoundSpecialsOddsHistoryStep1 from './containers/RoundSpecialsOddsHistoryStep1';
import RoundSpecialsOddsHistoryStep2 from './containers/RoundSpecialsOddsHistoryStep2';

function MainRouter() {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <Routes>
      <Route path={PAGES.LOGIN} element={<Login />} />
      <Route path={`${PAGES.MAIN}/*`} element={<Main />}>
        <Route path={PATHS.TEAMS} element={<Teams navigate={navigate} />} />
        <Route path={PATHS.ODDS_HISTORY_STEP_1} element={<SoccerOddsHistory1 />} />
        <Route path={PATHS.TENNIS_ODDS_HISTORY_STEP_1} element={<TennisOddsHistory1 />} />    
        <Route path={PATHS.ODDS_HISTORY_STEP_2} element={<SoccerOddsHistory2 />} />
        <Route path={PATHS.TENNIS_ODDS_HISTORY_STEP_2} element={<TennisOddsHistory2 />} />
        <Route path={PATHS.MATCH_TIMELINE} element={<MatchTimeline />} />
        <Route path={PATHS.MATCH_TIMELINE_HISTORY} element={<MatchTimeline isHistory />} />
        <Route path={PATHS.TENNIS_MATCH_TIMELINE} element={<TennisMatchTimeline />} />
        <Route exact path={PATHS.EVENTS} element={<SoccerEvents />} />
        <Route path={PATHS.TENNIS_EVENTS_VIEW} element={<TennisEvents />} />
        <Route path={PATHS.AUTO_BOOKING} element={<SoccerAutoBooking />} />
        <Route path={PATHS.TENNIS_AUTO_BOOKING} element={<TennisAutoBooking />} />
        <Route path={PATHS.RESULTS} element={<ResultsIframe />} />
        <Route path={PATHS.ADMIN_USERS_VIEW} element={<UserSettings />} />
        <Route path={PATHS.ADMIN_ROLES_VIEW} element={<RolesSettings />} />
        <Route path={PATHS.MY_PROFILE} element={<Profile />} />
        <Route path={PATHS.FEED_SETTINGS} element={<SoccerFeedSettings />} />
        <Route path={PATHS.TENNIS_FEED_SETTINGS} element={<TennisFeedSettings />} />
        <Route path={PATHS.MARKET_SETTINGS} element={<SoccerMarketSettings />} />
        <Route path={PATHS.TENNIS_MARKET_SETTINGS} element={<TennisMarketSettings />} />
        <Route path={PATHS.PLAYERS_TEMPLATE} element={<SoccerPlayerTemplate />} />
        <Route path={PATHS.LIVE_TEMPLATE} element={<LiveTemplate />} />
        <Route path={PATHS.TENNIS_LIVE_TEMPLATE} element={<TennisLiveTemplate />} />
        <Route path={PATHS.PLAYERS_TEMPLATE_FILE} element={<SoccerPlayersTemplateFile />} />
        <Route path={PATHS.LIVE_TEMPLATE_FILE} element={<LiveTemplateFile />} />
        <Route path={PATHS.TENNIS_LIVE_TEMPLATE_FILE} element={<TennisLiveTemplateFile />} />
        <Route path={PATHS.MARKET_MARGINS} element={<MarketMarginsSoccer />} />
        <Route path={PATHS.TENNIS_MARKET_MARGINS} element={<MarketMarginsTennis />} />
        <Route path={PATHS.EARLY_PAYOUT_CONFIG} element={<EarlyPayoutSettings navigate={navigate} />} />
        <Route path={PATHS.GOLDEN_GOAL_SETTNGS} element={<GoldenGoalSettings navigate={navigate} />} />
        <Route path={PATHS.PREMATCH_MARKET} element={<PrematchMarket />} />
        <Route path={PATHS.LIVE_SCORE_STATUS} element={<LiveScoreStatus />} />
        <Route path={PATHS.SOCCER_HISTORICAL_EVENTS} element={<HistoricalEvents />} />
        <Route path={PATHS.FEATURES_FLAG} element={<FeaturesFlag />} />
        <Route path={PATHS.ROUND_SPECIALS} element={<RoundSpecials />} />
        <Route path={PATHS.ROUND_SPECIALS_ROUND_TIMELINE} element={<RoundSpecialsMatchTimeline />} />
        <Route path={PATHS.ROUND_SPECIALS_ODDS_HISTORY_STEP1} element={<RoundSpecialsOddsHistoryStep1 />} />
        <Route path={PATHS.ROUND_SPECIALS_ODDS_HISTORY_STEP2} element={<RoundSpecialsOddsHistoryStep2 />} />
      </Route>
      <Route path={PAGES.HOME} element={<Menu
        navigate={navigate}
        location={location}
      />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

export default MainRouter;
